export const MLV_NOTIF_TIPO_RESENA = 'pedir_resena_vendedor';
export const MLV_NOTIF_TIPO_AVISO_UBICACION = 'aviso_denuncia_ubicacion';
export const MLV_NOTIF_TIPO_TARJETA_SERVICIO = 'tarjeta_servicio_cliente';
export const MLV_NOTIF_TIPO_MODERACION_ELIM = 'moderacion_publicacion_eliminada';

export function countPendientesResenaNotif(items) {
  const list = Array.isArray(items) ? items : [];
  return list.filter((x) => {
    if (x.leida === true) return false;
    if (x.tipo === MLV_NOTIF_TIPO_RESENA && String(x.vendedor_uid || '').trim()) return true;
    if (x.tipo === MLV_NOTIF_TIPO_AVISO_UBICACION) return true;
    if (x.tipo === MLV_NOTIF_TIPO_TARJETA_SERVICIO && String(x.profesional_uid || '').trim()) return true;
    if (x.tipo === MLV_NOTIF_TIPO_MODERACION_ELIM) return true;
    return false;
  }).length;
}

/** Actualiza contadores en perfil y catálogo (si el nodo existe). */
export function applyMlvResenaNotifBadges(count) {
  const n = Math.max(0, Number(count) || 0);
  for (const id of ['perfil-notif-badge', 'cat-notif-badge']) {
    const badge = document.getElementById(id);
    if (!badge) continue;
    badge.textContent = n > 0 ? String(n) : '';
    badge.classList.toggle('hidden', n === 0);
  }
}
